import apiClient from "./axios"; // same axios instance

const approvalApi = {

  // 🔍 Fetch approval details using token
  getByToken(token) {
    return apiClient.get(`api/loans/by-token/${token}`);
  },

  // ✅ Take approval action (APPROVE / REJECT)
  takeAction(token, decision, editedPayload = null) {
    return apiClient.post(`api/loans/approvals/action/${token}?decision=${decision}`, editedPayload);
  }

};

export default approvalApi;
